import { createUseStyles } from "react-jss";

export default createUseStyles({
    drillDown: {
        composes: "drill-down",
    },
    variable: {
        composes: "drill-down__variable",
    },
    label: {
        composes: "drill-down__label",
        display: "block",
        fontWeight: 600,
        marginTop: 20,
        marginBottom: 4,
    },
});
